import { AccountPageRoutes } from '../account/account.page-routes';
import { PlanPageRoutes } from '../plan/plans.routes';
import { UserPageRoutes } from '../user/user.page-routes';

export const RoutesDefinitions = [AccountPageRoutes, UserPageRoutes, PlanPageRoutes];
